module.exports = __webpack_public_path__ + "6b35abecd80149e32d4f6f4f86e89d50.svg";